import React from 'react';
import PropTypes from 'prop-types';
import PlanSpeedIndecator from '../PlanSpeedIndecator/PlanSpeedIndecator';
import './PlanDetails.scss';

const PlanDetails = (props) => {
  const dealClass = props.isSpecial ? 'special-deal' : '';
  return (
    <div className="plan-details-display current-plan-details">
      <div className="plan-details">
        <div className={`${dealClass} sub-section-title autotest-plan-details-${props.id}`}>
          {props.label}
        </div>
        {props.planStateText &&
        <span className="plan-state-message">{props.planStateText}</span>
        }
        <p className="radio-description">
          {props.description}
        </p>
        <div className="plan-speeds">
          <div className="plan-speed-download">
            <PlanSpeedIndecator speedData={props.download} />
          </div>
          <div className="plan-speed-upload">
            <PlanSpeedIndecator speedData={props.upload} />
          </div>
        </div>
      </div>
      {props.price &&
      <div className={'price-box'}>
        <div className={dealClass}>
          {props.previousPrice &&
          <div className="previous-price">
            Was {props.previousPrice}
          </div>
          }
          <div className="price">
            {props.price}
          </div>
          <div className="term-text">
            {props.termText}
          </div>
        </div>
      </div>
      }
    </div>
  );
};

PlanDetails.defaultProps = {
  termText: 'per month'
};

PlanDetails.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  download: PropTypes.object,
  upload: PropTypes.object,
  isSpecial: PropTypes.bool,
  planStateText: PropTypes.string,
  price: PropTypes.string,
  previousPrice: PropTypes.string,
  termText: PropTypes.string
};

export default PlanDetails;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/PlanDetails/PlanDetails.js
 **/